<template>
  <page-header :breadcrum-routes="routes" title="Integraciones" />
  <a-card>
    <a-typography-title :level="4" class="text-gray-8 mr-5">
      Stock movimientos de intregaciones
    </a-typography-title>
    <IntegrationMovementsTable
      @view-movement="
        (id) =>
          router.push({
            name: 'integration-movement-detail',
            params: { id }
          })
      "
    />
  </a-card>
</template>
<script setup>
import { useStore } from 'vuex';
import { onMounted, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENTS,
  INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT_TYPES,
  INTEGRATION_MOVEMENTS_GET_ERROR,
  COMPANIES_FETCH_COMPANIES,
  INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT_STATES,
  // TODO: change store of brokers
  FETCH_ALL_BROKERS
} from '@/store/types';
import PageHeader from '@/components/page-header.vue';
import IntegrationMovementsTable from '@/new-components/integration/movements/integration-movements-table.vue';
import notification from '@/utils/notifications';

const store = useStore();
const route = useRoute();
const router = useRouter();

const routes = [
  {
    breadcrumbName: 'Integraciones'
  }
];

const error = computed(
  () => store.getters[INTEGRATION_MOVEMENTS_GET_ERROR].fetchIntegrationMovements
);

watch(error, (newError) => {
  if (newError) {
    notification('error', 'Error', newError);
  }
});

onMounted(() => {
  store.dispatch(INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENTS, {
    ...route.query,
    companyIds: Array.isArray(route.query.companyIds)
      ? route.query.companyIds
      : route.query.companyIds
      ? [route.query.companyIds]
      : [],
    stateIds: Array.isArray(route.query.stateIds)
      ? route.query.stateIds
      : route.query.stateIds
      ? [route.query.stateIds]
      : [],
    page: route.query.page || 1,
    size: route.query.size || 10
  });
  store.dispatch(INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT_TYPES, {});
  store.dispatch(INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT_STATES);
  store.dispatch(COMPANIES_FETCH_COMPANIES, {});
  store.dispatch(FETCH_ALL_BROKERS);
});
</script>
